import React from 'react';
import styled from 'styled-components';

const TabContainer = styled.div`
  width: 100%;
`;

const TabList = styled.div`
  display: flex;
  gap: 1rem;
  border-bottom: 2px solid #E8D5B5;
  margin-bottom: 2rem;
`;

const Tab = styled.button`
  padding: 1rem 2rem;
  background: none;
  border: none;
  color: ${props => props.$active ? '#4A3C31' : '#8C7355'};
  font-weight: ${props => props.$active ? '600' : '400'};
  border-bottom: 2px solid ${props => props.$active ? '#4A3C31' : 'transparent'};
  margin-bottom: -2px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: #4A3C31;
  }
`;

const TabContent = styled.div`
  display: ${props => props.$active ? 'block' : 'none'};
`;

const TabPanel = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabContainer>
      <TabList>
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            $active={activeTab === tab.id}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
          </Tab>
        ))}
      </TabList>
      {tabs.map((tab) => (
        <TabContent key={tab.id} $active={activeTab === tab.id}>
          {tab.content}
        </TabContent>
      ))}
    </TabContainer>
  );
};

export default TabPanel;
